import { Box, Button, Caption, Flex, Heading, Paper, Text } from '@mediahuis/chameleon-react';
import { FeaturesList } from "../../FeaturesList/index.js";
import { MultibrandBanner } from "../../multibrand/index.js";
import { RouteYouBanner } from "../../route-you/index.js";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MultibrandVitrineCard = _ref => {
  let {
    availableOnly,
    buttonCaption,
    buttonText,
    description,
    features,
    gap = '1rem',
    highlight,
    highlightColor,
    imageSrc,
    label,
    logoAlt,
    logoSrc,
    multibrandProps,
    priceCaption,
    priceText,
    routeYouBannerProps,
    testId,
    title,
    onClick
  } = _ref;
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    children: [/*#__PURE__*/_jsx(Box, {
      alignSelf: "center",
      bgColor: highlight ? highlightColor : 'primaryBase',
      height: 6,
      width: "100%",
      px: 3,
      py: 2,
      style: {
        borderTopLeftRadius: 'var(--border-radius-2)',
        borderTopRightRadius: 'var(--border-radius-2)',
        fontWeight: 'bold',
        visibility: label ? 'visible' : 'hidden',
        textAlign: 'center'
      },
      children: label && /*#__PURE__*/_jsx(Text, {
        fontFamily: "system",
        size: "Caption2",
        textAlign: "center",
        children: label
      })
    }), /*#__PURE__*/_jsx(Box, {
      borderRadius: 3,
      style: {
        border: highlight ? `2px solid var(--${highlightColor})` : '2px solid transparent',
        borderTopLeftRadius: highlight ? 0 : 'var(--space-3)',
        borderTopRightRadius: highlight ? 0 : 'var(--space-3)'
      },
      children: /*#__PURE__*/_jsxs(Paper, {
        borderRadius: 3,
        display: "flex",
        elevation: 2,
        flexDirection: "column",
        hoverable: true,
        style: {
          gap,
          paddingBottom: gap ? gap : '5%',
          paddingTop: gap ? gap : '5%'
        },
        onClick: onClick,
        children: [logoSrc ? /*#__PURE__*/_jsx(Box, {
          alignSelf: "center",
          height: "28px",
          position: "relative",
          width: "85%",
          children: /*#__PURE__*/_jsx("img", {
            alt: logoAlt,
            height: "100%",
            src: logoSrc,
            style: {
              objectFit: 'contain',
              objectPosition: 'center'
            },
            width: "100%"
          })
        }) : /*#__PURE__*/_jsx(Heading, {
          alignSelf: "center",
          fontFamily: "primary",
          fontWeight: "regular",
          color: "colorGrey60",
          level: 6,
          style: {
            width: '85%'
          },
          textAlign: "center",
          children: title
        }), /*#__PURE__*/_jsxs(Flex, {
          alignSelf: "center",
          flexDirection: "column",
          style: {
            gap: '0.5rem',
            width: '85%'
          },
          children: [priceCaption && /*#__PURE__*/_jsx(Text, {
            as: "p",
            fontFamily: "system",
            textAlign: "center",
            children: priceCaption
          }), /*#__PURE__*/_jsx(Text, {
            as: "p",
            fontFamily: "system",
            textAlign: "center",
            children: priceText
          })]
        }), /*#__PURE__*/_jsx(Text, {
          alignSelf: "center",
          as: "p",
          fontFamily: "system",
          style: {
            width: '85%'
          },
          textAlign: "center",
          children: description
        }), imageSrc && /*#__PURE__*/_jsx(Box, {
          alignSelf: "center",
          height: "100px",
          position: "relative",
          width: "85%",
          children: /*#__PURE__*/_jsx("img", {
            alt: title?.props?.source,
            height: "100%",
            src: imageSrc,
            style: {
              objectFit: 'contain'
            },
            width: "100%"
          })
        }), /*#__PURE__*/_jsx(Box, {
          alignSelf: "center",
          style: {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            width: '85%'
          },
          children: /*#__PURE__*/_jsx(FeaturesList, {
            gap: "1rem",
            availableOnly: availableOnly,
            hideUnavailable: !availableOnly,
            items: features
          })
        }), multibrandProps && /*#__PURE__*/_jsx(MultibrandBanner, {
          ...multibrandProps
        }), routeYouBannerProps && /*#__PURE__*/_jsx(RouteYouBanner, {
          ...routeYouBannerProps
        }), /*#__PURE__*/_jsxs(Flex, {
          alignSelf: "center",
          flexDirection: "column",
          style: {
            gap: '0.5rem',
            width: '85%'
          },
          children: [/*#__PURE__*/_jsx(Button, {
            "data-testid": testId,
            children: buttonText
          }), buttonCaption && /*#__PURE__*/_jsx(Caption, {
            color: "colorGrey60",
            textAlign: "center",
            children: buttonCaption
          })]
        })]
      })
    })]
  });
};
export default MultibrandVitrineCard;